module.exports = __webpack_public_path__ + "static/img/chanpin-3-1.18172f8f.png";